module.exports = __webpack_public_path__ + "img/orgFrameworkConfig.81d53bf4.svg";